import React, { PropTypes } from 'react';

// Components
import Navbar from './Navbar';

export default class Main extends React.Component {

	constructor(props) {
		super(props);
		this.state = { isRedirecting: false };
	}

	componentWillMount() {
		if ( this.props.login.credentials.token === null ) {
			this.setState({isRedirecting: true});
			this.props.router.push('/login');
		} else {
			this.props.actions.isTokenValid();
		} 
	}

	setPermissionState(valor) {
		this.setState({projects: valor});

	}

	render () {
		const content = this.props.login.isFetching || this.state.isRedirecting
			? <center><i className="fas fa-circle-notch fa-spin fa-fw" /></center>
			: this.props.children;		
		return (
			<div>
				<Navbar 
					username={this.props.login.credentials.username}
					isAdmin={this.props.login.isAdmin}
					isGisAdmin={this.props.login.isGisAdmin}
					isGisOnly={this.props.login.isGisOnly}
					logout={this.props.actions.logout} 
					pathname={this.props.location.pathname}
					projectaccess={this.props.login.projectaccess}
					choosenbyuser={this.props.login.choosenbyuser}
					setChoosenByUser={this.props.actions.setChoosenByUser}
					canChangeUser={this.props.newuser.canChangeUser}
				/>
				<div className="container">
					{content}
				</div>
			</div>
		);
	}
}

Main.propTypes = {
	router: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	login: PropTypes.object.isRequired,
	newuser: PropTypes.object.isRequired,
	children: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Home/Main.js